import { TBulkImportRow } from "@/features/learner/components/learner-bulk-import/bulk-import-mock";

// 一括取り込みの作業中データ (選択行 + 画面上の編集 / 一括変更 / 行削除) をタブ内で一時保持する。
// リロードしても消えないようにし、確定保存 or 戻るで破棄する。サーバには保存しない (staging はクライアント側)。
const BULK_IMPORT_ROWS_KEY = "learner-bulk-import-rows";
// 取り込み元 (visa 一括同期 / ファイル取り込み)。「戻る」で開き直すモーダルを判断するために保持する。
const BULK_IMPORT_SOURCE_KEY = "learner-bulk-import-source";

export type TBulkImportSource = "visa" | "file";

export const readBulkImportRows = (): TBulkImportRow[] | null => {
  try {
    const raw = sessionStorage.getItem(BULK_IMPORT_ROWS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as TBulkImportRow[]) : null;
  } catch {
    // 破損データ等は無視して未保持扱いにする
    return null;
  }
};

export const saveBulkImportRows = (rows: TBulkImportRow[]) => {
  try {
    sessionStorage.setItem(BULK_IMPORT_ROWS_KEY, JSON.stringify(rows));
  } catch {
    // 容量超過 / プライベートモード等で書けない場合はサイレントに無視する
  }
};

export const readBulkImportSource = (): TBulkImportSource => (sessionStorage.getItem(BULK_IMPORT_SOURCE_KEY) === "file" ? "file" : "visa");

export const saveBulkImportSource = (source: TBulkImportSource) => {
  try {
    sessionStorage.setItem(BULK_IMPORT_SOURCE_KEY, source);
  } catch {
    // 書けない場合は既定 (visa) 扱いになるだけなのでサイレントに無視する
  }
};

export const clearBulkImportRows = () => {
  try {
    sessionStorage.removeItem(BULK_IMPORT_ROWS_KEY);
    sessionStorage.removeItem(BULK_IMPORT_SOURCE_KEY);
  } catch {
    // no-op
  }
};
